const sectionCardCompareProductCss = `
[data-type='section-card-compare-product'] .card-compare-product-wrapper {
  padding: 40px 0;
  background-color: var(--background-color, #f7eee7);
  color: var(--text-color, #000000);
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-top-padding='false'] {
  padding-top: 0;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bottom-padding='false'] {
  padding-bottom: 0;
}

[data-type='section-card-compare-product'] .card-compare-product-container-wrapper {
  width: 100%;
}

[data-type='section-card-compare-product'] .card-compare-product-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
}

[data-type='section-card-compare-product'] .card-compare-product-title {
  margin-bottom: 20px;
}

[data-type='section-card-compare-product'] .card-compare-product-title:empty {
  display: none;
  margin-bottom: 0;
}

[data-type='section-card-compare-product'] .card-compare-product-title h1,
[data-type='section-card-compare-product'] .card-compare-product-title h2,
[data-type='section-card-compare-product'] .card-compare-product-title h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-compare-product'] .card-compare-product-title h1:last-child,
[data-type='section-card-compare-product'] .card-compare-product-title h2:last-child,
[data-type='section-card-compare-product'] .card-compare-product-title h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-compare-product'] .card-compare-product-title p {
  font-size: 16px;
  margin: 0 !important;
}

[data-type='section-card-compare-product'] .card-compare-product-title p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-compare-product'] .card-compare-product-images {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}

[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-text {
  position: absolute;
  top: 49%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 16px;
  background-color: var(--vs-bg-color, #121212);
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 0px solid #ffffff;
  margin: 0px;
  font-size: 16px;
  line-height: 100%;
  color: var(--vs-text-color, #ffffff);
  text-transform: unset;
  word-break: break-word;
}

[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-left,
[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-right {
  width: auto;
  height: auto;
  aspect-ratio: 12 / 12;
  border-radius: 20px;
  overflow: hidden;
}

[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-left img,
[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-left video,
[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-right img,
[data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-right video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  display: block;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 94%;
  margin: 0 auto;
  width: 100%;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-item {
  display: flex;
  justify-content: center;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-good {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: end;
  padding: 8px 10px;
  background-color: var(--good-bg-color, #4dc61c);
  color: var(--good-text-color, #ffffff);
  min-height: 42px;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-good .card-compare-functionality-good-text {
  flex: 1;
  text-align: right;
  font-size: 14px !important;
  line-height: normal;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-good .card-compare-functionality-good-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-good .card-compare-functionality-good-icon svg {
  width: 100%;
  height: 100%;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-good .card-compare-functionality-good-icon svg path {
  fill: var(--good-text-color, #ffffff);
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-bad {
  width: 50%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: start;
  padding: 8px 10px;
  background-color: var(--bad-bg-color, #f3f3f3);
  color: var(--bad-text-color, #000000);
  min-height: 42px;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-bad .card-compare-functionality-bad-text {
  flex: 1;
  text-align: left;
  font-size: 14px !important;
  line-height: normal;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-bad .card-compare-functionality-bad-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-bad .card-compare-functionality-bad-icon svg {
  width: 100%;
  height: 100%;
}

[data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-bad .card-compare-functionality-bad-icon svg path {
  fill: var(--bad-text-color, #000000);
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-product-images {
  direction: rtl;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-product-images > * {
  direction: ltr;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-functionality-list .card-compare-functionality-item {
  flex-direction: row-reverse;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-functionality-list .card-compare-functionality-good {
  border-radius: 0 100px 100px 0;
  justify-content: start;
  flex-direction: row-reverse;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-functionality-list .card-compare-functionality-good .card-compare-functionality-good-text {
  text-align: left;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-functionality-list .card-compare-functionality-bad {
  border-radius: 100px 0 0 100px;
  justify-content: end;
  flex-direction: row-reverse;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-bad-position='left'] .card-compare-functionality-list .card-compare-functionality-bad .card-compare-functionality-bad-text {
  text-align: right;
}

[data-type='section-card-compare-product'] .card-compare-product-wrapper[data-container-full-width='false'] .card-compare-product-container-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

@container (max-width: 768px) {
  [data-type='section-card-compare-product'] .card-compare-product-wrapper {
    padding: 16px 0;
  }

  [data-type='section-card-compare-product'] .card-compare-product-title h1,
  [data-type='section-card-compare-product'] .card-compare-product-title h2,
  [data-type='section-card-compare-product'] .card-compare-product-title h3 {
    font-size: 20px;
  }

  [data-type='section-card-compare-product'] .card-compare-product-title p {
    font-size: 14px;
  }

  [data-type='section-card-compare-product'] .card-compare-product-images {
    gap: 12px;
  }

  [data-type='section-card-compare-product'] .card-compare-product-images .card-compare-product-image-text {
    font-size: 12px;
    padding: 10px;
  }

  [data-type='section-card-compare-product'] .card-compare-functionality-list {
    max-width: 100%;
  }

  [data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-good .card-compare-functionality-good-text {
    font-size: 12px !important;
  }

  [data-type='section-card-compare-product'] .card-compare-functionality-list .card-compare-functionality-bad .card-compare-functionality-bad-text {
    font-size: 12px !important;
  }
}
`;
export default sectionCardCompareProductCss;
